import cx from 'classnames';
import { useRouter } from 'next/compat/router';
import styled from 'styled-components';
import { LOGOUT_URL } from '@pass-frontend/common/constants/paths';
import { useIntl } from '@pass-frontend/common/i18n';
import { useBreakpoints } from '@pass-frontend/utility/style-helpers';

const StyledMemberNotFound = styled.section`
  height: 100vh;
  margin: 48px auto auto;

  &.is-desktop {
    width: 616px;
  }

  &.is-responsive {
    padding: 0 16px;
  }

  .heading {
    margin-bottom: 16px;
    margin-top: 24px;
  }

  .body {
    margin-bottom: 32px;
  }
`;

export const MemberNotFound = () => {
  const { t } = useIntl();
  const router = useRouter();
  const { isDesktop, isResponsive } = useBreakpoints();

  return (
    <StyledMemberNotFound
      className={cx(
        'is-display-flex is-flex-direction-column is-align-items-center has-text-centered',
        {
          'is-desktop': isDesktop,
          'is-responsive': isResponsive,
        },
      )}
    >
      <h1 className="is-h1 has-text-blue-1 heading">
        {t('memberNotFoundPage.title')}
      </h1>
      <section className="body">{t('memberNotFoundPage.body')}</section>
      <button
        onClick={() => router?.push(LOGOUT_URL)}
        className="btn btn-primary"
      >
        {t('memberNotFoundPage.goToLoginButtonText')}
      </button>
    </StyledMemberNotFound>
  );
};
